import { render, staticRenderFns } from "./PlatformExportFileRecipientsComponent.vue?vue&type=template&id=0573925b&"
import script from "./PlatformExportFileRecipientsComponent.vue?vue&type=script&lang=js&"
export * from "./PlatformExportFileRecipientsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports